import { render } from "./CustomersOrderList.vue?vue&type=template&id=70f6f5e4&scoped=true&ts=true"
import script from "./CustomersOrderList.vue?vue&type=script&lang=ts"
export * from "./CustomersOrderList.vue?vue&type=script&lang=ts"

import "./CustomersOrderList.vue?vue&type=style&index=0&id=70f6f5e4&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f6f5e4"]])

export default __exports__